"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const core_1 = require("@material-ui/core");
const data_table_1 = tslib_1.__importDefault(require("../../../../../layouts/data-table"));
const react_redux_1 = require("react-redux");
const icons_1 = require("../../../../../utils/icons");
const Utils_1 = require("../../../../../utils/Utils");
const style_1 = tslib_1.__importDefault(require("../../../../../utils/style"));
function ModelTuningStep3(props) {
    const { allSavedModels, setSelectedFinalModel, setIsFinalModelSelected, handleGraphView, setLoading } = props;
    const [selectedModel, setSelectedModel] = react_1.useState(null);
    const [errorMessage, setErrorMessage] = react_1.useState("");
    const projectInfo = react_redux_1.useSelector((state) => state.ProjectInfo);
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        if (selectedModel !== null) {
            if (projectInfo.problemtype == 'rca_ms') {
                const report = Object.assign({}, allSavedModels[selectedModel], { graph_df_path: Utils_1.getRelativePath(allSavedModels[selectedModel].graph_df_path), graph_save_path: Utils_1.getRelativePath(allSavedModels[selectedModel].graph_save_path) });
                setSelectedFinalModel((prev) => (Object.assign({}, prev, { performancereport: report })));
            }
            else {
                setSelectedFinalModel(allSavedModels[selectedModel]);
            }
            setIsFinalModelSelected(true);
            setErrorMessage("");
        }
        else {
            setIsFinalModelSelected(false);
            setErrorMessage("Please select a model before proceeding.");
        }
        if (allSavedModels.length == 0) {
            setErrorMessage("");
        }
    }, [selectedModel, allSavedModels, setSelectedFinalModel, setIsFinalModelSelected]);
    const handleCheckBoxChange = (event, index) => {
        console.log('checked', index, event.target.checked);
        if (event.target.checked) {
            setSelectedModel(prevSelected => (prevSelected === index ? null : index));
        }
    };
    const formatValue = (value) => {
        return typeof value === 'number' ? value.toFixed(3) : value;
    };
    const createParamsString = (params) => {
        return Object.entries(params)
            .map(([key, value]) => `${key}=${value}`)
            .join(", ");
    };
    const tableData = allSavedModels.length != 0 ?
        allSavedModels.map((model, index) => (Object.assign({ Select: (react_1.default.createElement(core_1.FormControlLabel, { label: "", style: { marginLeft: '0px' }, control: react_1.default.createElement(core_1.Checkbox, { checked: selectedModel === index, onChange: (event) => handleCheckBoxChange(event, index), style: { padding: "0px" }, color: "primary", inputProps: {
                        "aria-label": "primary checkbox",
                    } }), labelPlacement: "start" })) }, (projectInfo.problemtype !== 'rca_ms'
            ? Object.assign({ Algorithm: model.algorithm, "Model Parameters": createParamsString(model.parameters) }, Object.fromEntries(Object.entries(model.performancereport)
                .filter(([key]) => key !== 'algorithm')
                .map(([key, value]) => [key.replace(/_/g, ' '), formatValue(value)]))) : {
            Method: model.method,
            Graph: react_1.default.createElement(core_1.IconButton, null,
                react_1.default.createElement(icons_1.ViewIcon, null)),
        }))))
        :
            projectInfo.problemtype == 'rca_ms'
                ? [{ Method: "",
                        Graph: ""
                    }]
                : [];
    return (react_1.default.createElement(core_1.Grid, { container: true },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 1, lg: 1 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 10, lg: 10, style: { backgroundColor: "white", padding: "30px" } },
            react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, style: { padding: "0px 0px 20px", display: "flex" } }, "Save the current model within the project, train a new model, and review all the saved models."),
            selectedModel === null && (react_1.default.createElement(core_1.Typography, { color: "error", style: { textAlign: "center", marginBottom: '15px' } }, errorMessage)),
            react_1.default.createElement(data_table_1.default, { csvData: tableData, hideNoColumn: true, handleGraphView: handleGraphView })),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 1, lg: 1 })));
}
exports.ModelTuningStep3 = ModelTuningStep3;
//# sourceMappingURL=model-tuning-step3.js.map